import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useRef, useEffect } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  InputContainer,
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { ETriangleVM } from './EquilateralTriangleVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const ETriangleComponent = (props) => {
  const vm = useRef(new ETriangleVM(props)).current;
  const title = props.title.replace(/\s+/g,'_')
  useEffect(() => {
    vm.getFormData(`${props.section}_${title}_${props.id}`);
  }, []);

  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content">
        <InputContainer
          computeCallback={() => {
            vm.computeeTriangle();
          }}
          printCallback={() => {
            vm.launchAndExport();
          }}
          isLoading={vm.isLoading}
          disableCompute={vm.disableComputeBtn}
          disablePrint={!vm.hasResults}
        >
          <h2 className='sections-heading'>Specify</h2>
          <RadioGroup
            labelId="eTriangle-radio"
            items={[
              {
                id: 'radio-side-a',
                name: 'radio-side-a',
                label: "Side 'a'",
                className: 'usa-radio__input--tile',
                checked: vm.sideControl,
                onChange: vm.handleeTriangleForm,
              },
              {
                id: 'radio-height',
                name: 'radio-height',
                label: 'Height',
                className: 'usa-radio__input--tile',
                checked: vm.heightControl,
                onChange: vm.handleeTriangleForm,
              },
            ]}
          />
          <h2 className="sections-heading">General</h2>
          {vm.eTriangleFormControl === 0 ? (
            <>
              <Input
                label={vm.formLabelsForExport.sideA}
                idAndName="side-a"
                aria-label="side a"
                valid={!vm.formValidation.sideA}
                value={vm.eTriangleFormData.sideA}
                type="number"
                onChange={(e) => {
                  vm.handleeTriangleForm(e);
                }}
                step={0.01}
                onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
                className={vm.eTriangleErrorClass('sideA')}
                min={0.01}
              />
              <span className="calculated-box" contentEditable={false}>
                <label className="usa-label calculated-label" htmlFor="height">
                  {vm.formLabelsForExport.height}
                </label>
                <input
                  id="height"
                  aria-label="height"
                  className="disabled-input-box"
                  type="text"
                  aria-readonly="true"
                  readOnly
                  value={vm.eTriangleFormData.height}
                />
              </span>
            </>
          ) : (
            <>
              <Input
                label={vm.formLabelsForExport.height}
                idAndName="height"
                aria-label="height"
                valid={!vm.formValidation.height}
                value={vm.eTriangleFormData.height}
                type="number"
                onChange={(e) => {
                  vm.handleeTriangleForm(e);
                }}
                step={0.01}
                onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
                className={vm.eTriangleErrorClass('height')}
                min={0.01}
              />
              <span className="calculated-box" contentEditable={false}>
                <label className="usa-label calculated-label" htmlFor="sidea">
                  {vm.formLabelsForExport.sideA}
                </label>
                <input
                  id="sidea"
                  aria-label="sidea"
                  className="disabled-input-box"
                  type="text"
                  aria-readonly="true"
                  readOnly
                  value={vm.eTriangleFormData.sideA}
                />
              </span>
            </>
          )}
        </InputContainer>
        <div className="col formula-information ">
          {vm.hasResults ? (
            <div className="row formula-results ">
              <ResultsContainer>
                <div className="col-auto result-value-group">
                  <div className="row">
                    <div className="col-auto result-label">{vm.resultLabelsForExport.area}:</div>
                    <div className="col-auto result-value">{vm.roundingHelperString(vm.eTriangleResults?.area!, 2)}</div>
                  </div>
                </div>
              </ResultsContainer>
            </div>
          ) : (
            ''
          )}
          <div className="row formula-description">           
            <DescriptionContainer>
              <p>{vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              <img
                className="equilateral-triangle-img"
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const ETriangleFormula = observer(ETriangleComponent);
